var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container community-usage-chart"},[_c('div',{ref:"chartContainer",staticClass:"chart-element"})])
}
var staticRenderFns = []

export { render, staticRenderFns }